import { CtaButton } from '@/components/astro/cta-button/cta-button';

import { ResearchPapersVideo } from '@/components/astro/new-design/sections/research-papers-video';

export function HeroHeadingVideo({
  children,
  title,
}: {
  children: React.ReactNode;
  title: React.ReactNode;
}) {
  return (
    <>
      <section className='relative flex w-full flex-col-reverse items-center justify-center gap-[150px] overflow-hidden px-5 pt-13 pb-0 sm:px-14 sm:pt-12 sm:pb-[140px] md:gap-[100px] lg:flex-row-reverse lg:px-18'>
        <div className='flex w-full max-w-[1050px] flex-col items-center justify-center'>
          <div className='mx-auto flex w-full flex-col items-center justify-center gap-8'>
            <div className='mx-auto flex max-w-[920px] flex-col items-center gap-[27px]'>
              {title}

              {children}
              <div className='w-full text-center'>
                <CtaButton className='inline-block h-auto cursor-pointer rounded-full border-0 bg-azure-455 p-4 text-center text-[14px] leading-[18px] font-[600] text-neutral-50 no-underline sm:px-8 sm:py-3 sm:text-[18px] sm:leading-[24px]' />
              </div>
            </div>

            <ResearchPapersVideo />
          </div>
        </div>
      </section>

      <div className='absolute inset-x-0 top-0 z-[-1] h-[40vh] w-full bg-[linear-gradient(rgba(21,_112,_239,_0.2),_rgba(255,_255,_255,_0))]' />
    </>
  );
}
